import { h, Component } from "preact";
import { isMobile } from "services/utils";
import "./uploadPage.scss";

// tslint:disable: typedef
// tslint:disable: max-line-length

// https://external-content.duckduckgo.com/iu/?u=http%3A%2F%2F31.media.tumblr.com%2F9b5715a458e7305da1ca90ace0b40930%2Ftumblr_n4cvbdZ45t1tvkz4ro1_1280.png&f=1&nofb=1
// https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fs-media-cache-ak0.pinimg.com%2F736x%2F8f%2Feb%2Fa0%2F8feba0e72974e2b570478853a52945ba.jpg&f=1&nofb=1

export interface IUploadPageProps {
    compactLayout?: boolean;
}

interface IUploadPageState {
    isMobile: boolean;
}

export class UploadPage extends Component<IUploadPageProps, IUploadPageState> {
    constructor(props: IUploadPageProps) {
        super(props);

        this.state = {
            isMobile: isMobile()
        };
    }

    render(props: IUploadPageProps, state: IUploadPageState) {
        const layoutClass = this.state.isMobile
            ? "uploadpage uploadpage--mobile"
            : "uploadpage";

        return (
            <div id="pagecontainer" class={layoutClass}>
                <h1>Drop file to upload</h1>
                <svg version="1.1" x="0px" y="0px" viewBox="0 0 1000 1000" style="padding: 20px;" class="uploadpage__icon">
                    <g>
                        <path fill="#ddd" d="M500,10C229.4,10,10,229.4,10,500c0,270.6,219.4,490,490,490c270.6,0,490-219.4,490-490C990,229.4,770.6,10,500,10z M353.3,314.1L353.3,314.1l117.6-130.7l0,0c7.2-8,17.6-13,29.1-13s22,5,29.1,13v0l117.6,130.7h0c6.3,6.9,10.1,16.1,10.1,26.2c0,21.6-17.6,39.2-39.2,39.2c-11.6,0-22-5-29.1-13l0,0l-49.3-54.7V569c0,21.7-17.5,39.2-39.2,39.2c-21.6,0-39.2-17.6-39.2-39.2V311.8l-49.3,54.7c-7.2,8-17.6,13-29.1,13c-21.6,0-39.2-17.5-39.2-39.2C343.2,330.2,347,321.1,353.3,314.1z M839.7,762.5c0,21.7-17.5,39.2-39.2,39.2h-601c-21.6,0-39.2-17.5-39.2-39.2v-196c0-21.6,17.5-39.2,39.2-39.2s39.2,17.6,39.2,39.2v156.8h522.6V566.5c0-21.6,17.6-39.2,39.2-39.2c21.7,0,39.2,17.6,39.2,39.2L839.7,762.5L839.7,762.5z" />
                    </g>
                </svg>
            </div>
        );
    }
}
